import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootEpic } from "common/type-state";
import {
    filter,
    switchMap,
    map,
    catchError,
    takeWhile,
    withLatestFrom,
} from "rxjs/operators";
import { interval, merge, of } from "rxjs";
import {
    DOCAIApi,
    ExtractFileRequest,
    FileAnalytic,
    FileAnalyticStatus,
} from "../api/docai.api";

interface DOCAIState {
    loading: boolean;
    fileAnalytic: FileAnalytic | null;
    fileStatus: FileAnalyticStatus | null;
    error: string | null;
}

const initialState: DOCAIState = {
    loading: false,
    fileAnalytic: null,
    fileStatus: null,
    error: null,
};

const DOCEAISlice = createSlice({
    name: "docai",
    initialState,
    reducers: {
        extractFileRequest: (
            state,
            _action: PayloadAction<ExtractFileRequest>
        ) => {
            state.loading = true;
            state.error = null;
        },
        extractFileSuccess: (state, action: PayloadAction<FileAnalytic>) => {
            state.loading = false;
            state.fileAnalytic = action.payload;
        },
        extractFileFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        getFileStatusRequest: (state, action: PayloadAction<string>) => {
            state.loading = true;
            state.error = null;
        },
        getFileStatusSuccess: (
            state,
            action: PayloadAction<FileAnalyticStatus>
        ) => {
            state.loading = false;
            state.fileStatus = action.payload;
        },
        getFileStatusFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const extractFileByPathFile$: RootEpic = (action$, state$) =>
    action$.pipe(
        filter(DOCAIActions.extractFileRequest.match),
        switchMap((action) =>
            DOCAIApi.extractFileByPathFile(action.payload).pipe(
                switchMap((res) => {
                    const poll$ = interval(1000).pipe(
                        withLatestFrom(state$),
                        takeWhile(([_, state]) => {
                            const status = state.docai.fileStatus?.status || "";
                            return status !== "success"; // continue while not 'success'
                        }),
                        map(() =>
                            getFileStatusRequest(action.payload.guid_file)
                        )
                    );

                    return merge(
                        of(DOCAIActions.extractFileSuccess(res)),
                        poll$
                    );
                }),
                catchError((err) =>
                    of(
                        DOCAIActions.extractFileFailure(
                            err.message || "Lỗi khi trích xuất file"
                        )
                    )
                )
            )
        )
    );
export const getFileStatusByGuidFile$: RootEpic = (action$) =>
    action$.pipe(
        filter(DOCAIActions.getFileStatusRequest.match),
        switchMap((action) =>
            DOCAIApi.getTaskByGuidFile(action.payload).pipe(
                map((res) => DOCAIActions.getFileStatusSuccess(res)),
                catchError((err) =>
                    of(
                        DOCAIActions.getFileStatusFailure(
                            err.message || "Lỗi khi lấy trạng thái file"
                        )
                    )
                )
            )
        )
    );

export const DOCAIEpics = [extractFileByPathFile$, getFileStatusByGuidFile$];
export const {
    getFileStatusRequest,
    getFileStatusFailure,
    getFileStatusSuccess,
    extractFileRequest,
    extractFileSuccess,
    extractFileFailure,
} = DOCEAISlice.actions;
export const DOCAIActions = DOCEAISlice.actions;
export default DOCEAISlice.reducer;
